// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__1Mn-V","title":"BackImages_title__J7Iby","images":"BackImages_images__14gKo"};